export default "__VITE_ASSET__BZtgqtoX__"